export enum CodeResponse {
  ACCEPTED = 0,
  ERROR =  1
}
